import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const SignupIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.521 20.4412C12.7122 20.6513 11.8718 20.7668 11 20.7668C5.47479 20.7668 1 16.2921 1 10.7668C1 5.24164 5.47479 0.766846 11 0.766846C16.5252 0.766846 21 5.24164 21 10.7668C21 12.9307 20.3172 14.9265 19.1513 16.5652"
        stroke={color ?? 'current-color'}
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9988 11.3131C12.6464 11.3131 13.982 9.97745 13.982 8.32987C13.982 6.6823 12.6464 5.34668 10.9988 5.34668C9.35125 5.34668 8.01562 6.6823 8.01562 8.32987C8.01562 9.97745 9.35125 11.3131 10.9988 11.3131Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.65234 18.9917C5.65234 16.04 8.0473 13.645 10.999 13.645C12.6586 13.645 14.1397 14.4013 15.1166 15.5883"
        stroke={color ?? 'current-color'}
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5273 16.9226V20.6411"
        stroke={color ?? 'current-color'}
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3852 18.7817H14.6562"
        stroke={color ?? 'current-color'}
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SignupIcon;
